import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class CorpFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.footer} dangerouslySetInnerHTML={{ __html: content.footer }} />;
    }
}

export default errorBoundary(CorpFooter);
